import {
    SESSION_LOAD,
    SESSION_LOGIN,
    SESSION_LOGOUT,
    SESSIONITEMS_LOAD,
    SESSIONITEMS_UNLOAD,
    SESSIONITEMS_SET
} from './actionDefinitions';
import { createReducer } from './reducerUtils';
import store from './store';

const initialState = {
    error: undefined,
    message: undefined,
    forgotPassword: false,
    forgotPasswordResult: undefined,
    temporaryLinkText: undefined,
    temporaryLink: undefined,
    resetPasswordResult: undefined,
    serverState: { EnvironmentType: -1, InstanceStartTime: undefined },
    currentUser: undefined,
    currentClient: undefined,
    signals: undefined,
    surveyAssignments: [],
    permissions: undefined,
    calibratorSurveyAssignments: [],
    internalSurveyAssignments: [],
    databaseTimeCorrectionMs: 0,
    isFetching: false,
    desktopName: undefined,
    desktopVersion: undefined,
    desktopUserName: undefined,
    desktopAttemptLogin: true,
    FileMaxRequestLength: undefined,
    common: undefined
};

const handlers = {
    [SESSION_LOAD]: (state, action) => action.payload,
    [SESSION_LOGIN]: (state, action) => {
        if (action.isFetching) {
            return { isFetching: true };
        }
        else if (!action.error) {
            return { payload: action.payload, isFetching: false };
        }
        return { error: action.payload.message, isFetching: false  };
    },
    [SESSION_LOGOUT]: () => {
        const session = store.getState().session;
        if (session.serverState) return Object.assign({ initialState }, { serverState: session.serverState });
        else return initialState;
    },
    [SESSIONITEMS_LOAD]: (state, action) => {
        if (!action.error) {
            action.payload.error = undefined;
            return action.payload;
        }
        return { error: action.payload };
    },
    [SESSIONITEMS_UNLOAD]: () => ({
        currentUser: undefined,
        currentClient: undefined,
        surveyAssignments: []
    }),
    [SESSIONITEMS_SET]: (state, action) => action.payload
};

export default createReducer(initialState, handlers);
